/* eslint-disable no-unused-vars */
import api from 'configs/api';

import {
  IIndisp,
  IComment,
  IActivityOptions,
  YesOrNo,
  IMaintenanceType,
  IPlannedActivityFilterData,
} from 'interfaces/Activity';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { IRequestResponse } from 'interfaces/RequestResponse';

const endpointUrl = 'activity';

export const postActivity = async params => {
  const url = `${endpointUrl}/plan`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postActivityUpdate = async params => {
  const url = `${endpointUrl}/planned/update`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const postActivityFilter = async (qsparams, params) => {
  const url = `${endpointUrl}/planned/filter?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IPlannedActivityFilterData>>(
    url,
    params,
  );
  return data;
};

export const postIndispFilter = async params => {
  const url = `${endpointUrl}/indisp/filter`;
  const { data } = await api.post<IRequestListResponse<IIndisp>>(url, params);
  return data;
};

export const postPauseActivity = async params => {
  const url = `${endpointUrl}/pause`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postUnpauseActivity = async params => {
  const url = `${endpointUrl}/unpause`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postReplanActivity = async params => {
  const url = `${endpointUrl}/replan`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const getComments = async params => {
  const url = `${endpointUrl}/comment`;
  const { data } = await api.post<IRequestListResponse<IComment>>(url, params);
  return data;
};

export const postActivityFilterOptions = async params => {
  const url = `${endpointUrl}/filter/name`;
  const { data } = await api.post<IRequestListResponse<IActivityOptions>>(
    url,
    params,
  );
  return data;
};

export const postCancelActivity = async params => {
  const url = `${endpointUrl}/cancel`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const getActivityMaintenanceType = async params => {
  const url = `${endpointUrl}/maintenance-type/filter`;
  const { data } = await api.get<IRequestListResponse<IMaintenanceType>>(
    url,
    params,
  );
  return data;
};

export const getYesOrNotOption = async params => {
  const url = `${endpointUrl}/yes-or-no/filter`;
  const { data } = await api.get<IRequestResponse<YesOrNo>>(url, params);
  return data;
};

export const deleteActivityPlanned = async params => {
  const url = `${endpointUrl}/planned/delete`;
  const { data } = await api.delete<IRequestResponse<null>>(url, {
    data: params,
  });
  return data;
};

export const activityByExecutorAndTypes = async params => {
  const url = `${endpointUrl}/activityByExecutorAndTypes`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};
